import { Dispatch, SetStateAction, createContext } from "react"

export interface InvestModal {
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
}

const InvestModalContext = createContext<InvestModal>({
    isOpen: false,
    setIsOpen: () => null
})

export default InvestModalContext
